import { ReactNode } from 'react';

import { Button } from '@gearbelt/ui/components';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

import ArchiveIcon from '@/components/icons/archive';
import CloseIcon from '@/components/icons/close';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

function ArchiveConfirmationDialog({
  open,
  onOpenChange,
  callback,
  loading,
  title,
  description,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: () => void;
  loading: boolean;
  title: ReactNode;
  description: ReactNode;
}) {
  function handleSubmit() {
    callback();
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col gap-[10px]">
        {/* Visually hidden for a11y */}
        <VisuallyHidden>
          <DialogTitle>{title}</DialogTitle>
        </VisuallyHidden>

        <DialogClose className="focus:ring-default-blue data-[state=open]:bg-default-blue/10 data-[state=open]:text-default-text ml-auto size-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:pointer-events-none">
          <CloseIcon className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogClose>

        <h1 className="text-center text-xl font-medium">{title}</h1>

        <DialogDescription className="text-center">{description}</DialogDescription>

        <div className="mt-4 flex justify-center gap-2">
          <Button variant="destructive" icon={<ArchiveIcon className="text-white" />} onClick={handleSubmit} loading={loading}>
            Archive
          </Button>
          <Button variant="grey" onClick={() => onOpenChange(false)} disabled={loading}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export { ArchiveConfirmationDialog };
